import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { Select } from '../../ui';

import { setVehiclesValue } from "../../../actions";
import { vehicles } from "../../../operations";
import { Body } from '../Form';
import Loader from '../Loader';
import Continue from "../Continue";
import {
  mapSelectList,
  arrayToSelectList
} from "../../../helpers";

import iconNumber from '../../../assets/icons/icon-number.svg';

class AutoForm_2 extends Component {

  constructor(props) {
    super(props);
    this.state = { continue: false };
    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    const {
      carBrands,
      getUsageAreas,
      getCarBrands
    } = this.props;

    this.checkContinueState(null);
    getUsageAreas();
    const { vehicleType, isSOA } = this.props;
    if(carBrands.length == 0) getCarBrands(vehicleType, isSOA);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {
    const {
      carBrand,
      carYear,
      carModel,
      carUsageArea
    } = this.props;

    return (
      carBrand != null &&
      carYear != null &&
      carModel != null &&
      carUsageArea != null
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {

    const {
      carBrand, onCarBrandChange,
      carBrands, carYear,
      onCarYearChange, carYears,
      showError, carModel,
      carModels, onValueChange,
      carUsageArea, usageAreas
    } = this.props;

    return (
      <div style={{marginTop: 25}}>
        <div className="AutosSoa-formRow AutosStandard-formRow">
          <div style={{ flex: 1 }}>
            <Select
              label="¿De qué marca es tu vehículo?"
              id="carBrand"
              leftIcon={iconNumber}
              name="carBrand"
              value={carBrand}
              showAlert={showError && !carBrand}
              onChange={onCarBrandChange}
              placeholder="Seleccione una marca"
              searchable={!isMobile}
              options={mapSelectList(carBrands, 'Code', 'Name')}
              disabled={(carBrands && carBrands.length < 1)}
              isLoading={(carBrands && carBrands.length < 1)}
              loadingMessage={() => "Cargando.."}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              label="¿De qué año?"
              id="carYear"
              leftIcon={iconNumber}
              name="carYear"
              value={carYear}
              showAlert={showError && !carYear}
              onChange={onCarYearChange}
              placeholder="Seleccione el año"
              searchable={!isMobile}
              options={arrayToSelectList(carYears)}
              isabled={(carYears && carYears.length < 1)}
              isLoading={(carBrand && carYears && carYears.length < 1)}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
        <div className="AutosSoa-formRow  AutosStandard-formRow">
          <div style={{ flex: 1 }}>
            <Select
              label="¿Cuál es el modelo?"
              id="carModel"
              leftIcon={iconNumber}
              name="carModel"
              value={carModel}
              showAlert={showError && !carModel}
              onChange={(value) => { onValueChange('carModel', value) }}
              placeholder="Seleccione un modelo"
              searchable={!isMobile}
              options={mapSelectList(carModels, 'Code', 'Name')}
              disabled={(carModels && carModels.length < 1)}
              isLoading={(carYear && carModels && carModels.length < 1)}
              loadingMessage={() => "Cargando.."}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              label="Zona de circulación"
              id="carUsageArea"
              leftIcon={iconNumber}
              name="carUsageArea"
              value={carUsageArea}
              showAlert={showError && !carUsageArea}
              onChange={(value) => { onValueChange('carUsageArea', value) }}
              placeholder="Seleccione una zona"
              searchable={!isMobile}
              options={mapSelectList(usageAreas, 'Code', 'Description')}
              disabled={(usageAreas && usageAreas.length < 1)}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;
    const { carBrands, getQuotation, isSOA } = this.props;

    return (
      <div>
        { carBrands.length == 0 ?
          <Loader /> :
          <div>
            <Body columnContent={this.getContent} />
            <Continue state={toContinue} onClick={() => { getQuotation(isSOA) }}/>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,
    vehicleType: state.vehicles.vehicleType,

    carBrand: state.vehicles.carBrand,
    carYear: state.vehicles.carYear,
    carModel: state.vehicles.carModel,
    carUsageArea: state.vehicles.carUsageArea,

    carBrands: state.vehicles.carBrands,
    carYears: state.vehicles.carYears,
    carModels: state.vehicles.carModels,
    usageAreas: state.vehicles.usageAreas,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUsageAreas: () => {
      dispatch(vehicles.getUsageAreas());
    },
    getCarBrands: (type, isSOA) => {
      dispatch(vehicles.getCarBrands(type, isSOA));
    },
    onValueChange: (type, value) => {
      dispatch(setVehiclesValue(type, value));
    },
    onCarBrandChange: (carBrand) => {
      dispatch(vehicles.setCarBrand(carBrand));
    },
    onCarYearChange: (carYear) => {
      dispatch(vehicles.setCarYear(carYear));
    },
    getQuotation: (isSOA) => {
      dispatch(vehicles.getQuotation(true, isSOA));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoForm_2);